export default "__VITE_ASSET__llGqaMeb__"